import { getLabel } from "../labels";

export function getTicketCategoryLabel(status) {
    switch (status) {
        case 'open':
        case 'in_progress':
            return getLabel('mybets.tipo.incorso', 'In corso');

        case 'winning':
        case 'paid':
        case 'to_be_paid':
        case 'win':
            return getLabel('mybets.vincita', 'Vincente');

        case 'winning_cashback':
            return getLabel('mybets.winning_cashback', 'Cashout');

        case 'losing':
        case 'lose':
        case 'lost':
            return getLabel('mybets.perdente', 'Perdente');

        case 'voided':
        case 'cancelled':
            return getLabel('mybets.annullata', 'Annullata');

        default:
            return getLabel('mybets.tipo.incorso', 'In corso');
    }
}